import React from 'react';
import Icon from '../../../components/AppIcon';

const QuoteSummary = ({ summary, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-surface border border-border rounded-lg p-6 mb-6">
        <div className="animate-pulse">
          <div className="h-6 bg-muted rounded w-1/3 mb-4"></div>
          <div className="space-y-3">
            {[1, 2, 3, 4]?.map((i) => (
              <div key={i} className="flex justify-between">
                <div className="h-4 bg-muted rounded w-1/3"></div>
                <div className="h-4 bg-muted rounded w-1/6"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    })?.format(price);
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-6 mb-6 shadow-soft">
      <h2 className="text-lg font-semibold text-text-primary mb-4 flex items-center space-x-2">
        <Icon name="Calculator" size={20} />
        <span>Récapitulatif</span>
      </h2>
      <div className="space-y-3">
        <div className="flex justify-between items-center py-2">
          <span className="text-text-secondary">Sous-total HT:</span>
          <span className="text-text-primary font-medium">{formatPrice(summary?.subtotal)}</span>
        </div>

        {summary?.discount > 0 && (
          <div className="flex justify-between items-center py-2">
            <span className="text-text-secondary">Remise:</span>
            <span className="text-success font-medium">-{formatPrice(summary?.discount)}</span>
          </div>
        )}

        <div className="flex justify-between items-center py-2">
          <span className="text-text-secondary">
            TVA ({summary?.vatRate}%):
          </span>
          <span className="text-text-primary font-medium">{formatPrice(summary?.vatAmount)}</span>
        </div>

        <div className="border-t border-border pt-3">
          <div className="flex justify-between items-center">
            <span className="text-lg font-semibold text-text-primary">Total TTC:</span>
            <span className="text-xl font-bold text-primary">{formatPrice(summary?.total)}</span>
          </div>
        </div>

        {summary?.vatType === 'self-liquidation' && (
          <div className="mt-4 p-3 bg-warning/10 border border-warning/20 rounded-md">
            <div className="flex items-start space-x-2">
              <Icon name="Info" size={16} className="text-warning mt-0.5" />
              <div>
                <p className="text-sm font-medium text-warning">Auto-liquidation de la TVA</p>
                <p className="text-xs text-text-secondary mt-1">
                  La TVA sera auto-liquidée par le client selon la réglementation en vigueur.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuoteSummary;